<template>
    <div>
        <TabWrapper>
            <v-container fluid>
                <v-row justify="center" no-gutters>
                    <v-col cols="12" lg="10">
                        <Datatable :items="domains" :headers="tableHeaders" :key="key"
                                   @click:delete="openActionDialog" title="Domains">
                            <template #top>
                                <div v-if="!readOnly" style="display:flex; align-items: center">
                                    <Button v-if="$vuetify.breakpoint.smAndUp" class="ml-8"
                                            icon="mdi-plus" @click="openDialog"
                                            :color="ada.blue">Domain hinzufügen
                                    </Button>
                                    <TooltipIcon v-else :color="ada.blue" :fab="true"
                                                 @click="openDialog"
                                                 tooltip="Domain hinzufügen">mdi-plus
                                    </TooltipIcon>
                                </div>
                            </template>
                        </Datatable>
                    </v-col>
                </v-row>
            </v-container>
        </TabWrapper>
        <AddDomainDialog v-model="showDomainDialog"></AddDomainDialog>
        <DeleteDomainDialog v-model="showDeleteDomainDialog" :domain="selectedDomain"></DeleteDomainDialog>
    </div>
</template>

<script>
import TabWrapper from "./TabWrapper";
import Utils from "../../../scripts/Utils";
import ada from "../../../scss/ada_colors.scss";
import TooltipIcon from "../../../components/TooltipIcon";
import Button from "../../../components/buttons/Button";
import AddDomainDialog from "../Dialogs/AddDomainDialog";
import DeleteDomainDialog from "../Dialogs/DeleteDomainDialog";
import Datatable from "../../../components/Tables/Datatable";

export default {
    name: "Domains",
    components: {Datatable, DeleteDomainDialog, AddDomainDialog, Button, TooltipIcon, TabWrapper},
    props: ['readOnly'],
    data: () => {
        return {
            search: null,
            headers: [
                {text: 'Name', value: 'Domain'},
                {text: 'Erstellt am', value: 'created_at', width: '200px'},
            ],
            showDomainDialog: false,
            showDeleteDomainDialog: false,
            selectedDomain: null,
            key: 0,
            ada
        }
    },
    mounted() {
        this.$emit('activeComponent', this);
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        domains() {
            let ret = this.siteDetails ? this.siteDetails.Domains : [];
            ret.forEach((item) => {
                item.created_at = Utils.formatDate(item.Created);
                item.action = [];
                if (!this.readOnly) item.action.push('delete');
            });
            return ret;
        },
        tableHeaders() {
            let ret = JSON.parse(JSON.stringify(this.headers));
            if (!this.readOnly) ret.push({text: 'Aktion', value: 'action', width: '100px', sortable: false});
            return ret;
        },
        activeTab() {
            return this.$store.state.display.activeTab;
        }
    },
    methods: {
        date(dateStr) {
            return Utils.formatDate(dateStr);
        },
        openDialog() {
            this.selectedDomain = null;
            this.showDomainDialog = true;
        },
        openActionDialog(item) {
            this.selectedDomain = item;
            this.showDeleteDomainDialog = true;
        }
    },
    watch: {
        activeTab() {
            if (this.activeTab === this.$options._componentTag) {
                this.$emit('activeComponent', this);
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>